module.exports = __webpack_public_path__ + "static/media/car.1f5ef196.svg";